/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useState } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import ChoiceSection from '../../components/ChoiceSection';
import ApplicationContext from '../../context/ApplicationContext';
import IdentificationHeader from './IdentificationHeader';
import { dataService } from '../../services/data.service';
import BackButton from '../../components/Button/BackButton';
import { identificationLanguageContent } from './IdentificationLanguageContent';

function IdentityDocument(props) {
    const { handlePage, setIdCardData, setLoading, sessionData, selectedLanguage } = useContext(ApplicationContext);
    const [selectedChoice, setSelectedChoice] = useState('');

    const handleNavigation = (choice) => {
        setLoading(true);
        const payload = {
            is_idenity_present: choice === 'Yes' ? true : false
        }
        dataService.updateIDDetails(sessionStorage.getItem('session'), payload).then((res) => {
            if(res.error === false) {
                if(choice === 'Yes') {
                    handlePage('upload_id_choice', '', '', sessionData['review'] === 'previous' ? 'previous' : '')
                } else {
                    handlePage('insurance', 'identity', '', sessionData['review'] === 'previous' ? 'previous' : '');
                }
            }
        })
    }
    const getIdentityCardDetails = () => {
        dataService.getIDCardDetails(sessionStorage.getItem('session')).then((res) => {
            if(res.error === false) {
                setIdCardData(res.data.data);
            }
        })
    }
    useEffect(() => {
        getIdentityCardDetails();
    }, [])

    const handleBack = () => {
        if(sessionData['review'] === 'previous') {
            handlePage('review');
        } else {
            handlePage('appointments')
        }
    }
    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-hidden'>
            <div className='p-[8px]'>
                <IdentificationHeader />
                <div className='mt-[18px]'>
                    <ChoiceSection callback={true} handleNext={handleNavigation} event="id" question={identificationLanguageContent['identity-question'][selectedLanguage]} 
                        selectedChoice={selectedChoice} setSelectedChoice={setSelectedChoice} choice1="Yes" choice2="No" />
                </div>
            </div>
            <div className='flex mb-[24px] justify-between mx-[16px] w-[40%] fold-gap'>
                <BackButton handleClick={() => handleBack()} backType="previous" />
            </div>
        </AnimatedPageFade>
    );
}

export default IdentityDocument;